<template>
  <ExtracadabraModal
    v-model:opened="internalOpen"
    :header="{
      title: campaign.getTitle(),
      hideCloseBtn: true,
    }"
    :quasar-props="{
      noEscDismiss: true,
      noBackdropDismiss: true,
      maximized: false,
    }"
    :card="{ class: 'extra-marketing-campaign-modal' }"
    size="sm"
  >
    <template #body>
      <!-- eslint-disable-next-line vue/no-v-html -->
      <div v-html="body" />
    </template>
    <template #footer>
      <QBtn v-if="!shouldHideCancelBtn" class="btn-navigation-half" color="primary" flat no-caps :label="cancelBtnLabel" @click="close" />
      <QBtn
        :class="shouldHideCancelBtn ? 'btn-navigation full-width' : 'btn-navigation-half'"
        color="secondary"
        no-caps
        :label="actionBtnLabel"
        @click="action"
      />
    </template>
  </ExtracadabraModal>
</template>

<script>
  import { SanitationHelper } from "@core/helpers";
  import { MarketingCampaignModel } from "@core/models";
  import { MARKETING_CAMPAIGN_TYPES } from "@core/constants";
  import { ExtracadabraModal } from "@core/components/modals";

  export default {
    components: {
      ExtracadabraModal,
    },
    props: {
      opened: {
        type: Boolean,
        default: false,
      },
      campaign: {
        type: Object,
        default: () => new MarketingCampaignModel(),
      },
    },
    emits: ["update:opened", "close", "action"],
    computed: {
      internalOpen: {
        get() {
          return this.opened;
        },
        set() {
          this.$emit("update:opened", false);
        },
      },
      body() {
        return SanitationHelper.sanitize(this.campaign.getBody());
      },
      shouldHideCancelBtn() {
        return this.campaign.getType() === MARKETING_CAMPAIGN_TYPES.SIMPLE;
      },
      cancelBtnLabel() {
        return this.campaign.getCancelBtnLabel() || this.$t("ETAB.MODALS.MARKETING_CAMPAIGN.@CANCEL");
      },
      actionBtnLabel() {
        // we keep the opportunity to define label in server
        const label = this.campaign.getActionBtnLabel();
        if (label) {
          return label;
        }
        // if there's no label, let's see what we can do
        switch (this.campaign.getType()) {
          case MARKETING_CAMPAIGN_TYPES.LINK:
            return this.$t("ETAB.MODALS.MARKETING_CAMPAIGN.@GO_TO_LINK");
          case MARKETING_CAMPAIGN_TYPES.ACTION:
            return this.$t("ETAB.MODALS.MARKETING_CAMPAIGN.@GO_TO_ACTION");
          case MARKETING_CAMPAIGN_TYPES.SIMPLE:
          default:
            return this.$t("ETAB.MODALS.MARKETING_CAMPAIGN.@OK");
        }
      },
    },
    methods: {
      close() {
        this.$emit("close", { campaign: this.campaign });
      },
      action() {
        this.$emit("action", { campaign: this.campaign });
      },
    },
  };
</script>

<style lang="scss">
  .extra-marketing-campaign-modal {
    img {
      display: block;
      max-width: 90vw;
      max-height: 50vh;
      width: auto;
      height: auto;
    }
  }
</style>
